import { Extension as y } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { Plugin as g, PluginKey as F } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { DEFAULT_FONT_SIZE as h } from "../../constants/default-styles.mjs";
import { unsetTextStyleAttribute as x } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
const T = new F("defaultFontSize"), I = y.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"],
      defaultFontSize: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (t) => t.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (t) => t.fontSize ? {
              style: `font-size: ${t.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (t) => ({ chain: n }) => n().setMark("textStyle", { fontSize: t }).run(),
      unsetFontSize: () => ({ tr: t, state: n, dispatch: d }) => x("fontSize", n, t, d)
    };
  },
  addProseMirrorPlugins() {
    const t = this.options.defaultFontSize;
    return t ? [
      new g({
        key: T,
        appendTransaction: (n, d, o) => {
          if (!n.some((r) => r.docChanged))
            return null;
          const l = o.tr;
          let u = !1;
          return o.doc.descendants((r, i) => {
            if (!r.isText)
              return;
            const s = o.doc.resolve(i).parent, c = s.type.name === "paragraph", m = s.type.name === "listItem", S = s.type.name === "heading";
            if (!c && !m || S)
              return;
            const e = r.marks.find((a) => a.type.name === "textStyle");
            if (!(e == null ? void 0 : e.attrs.fontSize)) {
              const a = i, z = i + r.nodeSize, f = o.schema.marks.textStyle;
              if (f) {
                const p = f.create({
                  ...e == null ? void 0 : e.attrs,
                  fontSize: t
                });
                l.addMark(a, z, p), u = !0;
              }
            }
          }), u ? l : null;
        }
      })
    ] : [];
  }
}), H = (t) => I.configure({
  defaultFontSize: t != null && t.clearable ? null : h
});
export {
  H as createFontSizeExtension
};
